import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsProjects } from "../../constants/projects";
import EDTs from "./EDTs";

const EDTsPage = ({ API_URL, typeWorks, user }) => {
  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div style={{ flex: 1, padding: "10px", width: "100%" }}>
        <EDTs API_URL={API_URL} typeWorks={typeWorks} user={user} />
      </div>
    </div>
  );
};

export default EDTsPage;
